import { render, staticRenderFns } from "./ChargeFeeInfoModal.vue?vue&type=template&id=36022b5f&"
import script from "./ChargeFeeInfoModal.vue?vue&type=script&lang=js&"
export * from "./ChargeFeeInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports